var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-07-20
 * @brief SEI 설비유형 Management  개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { reLoad, reloadSpg, userInfoLoginState } from "../../../recoil/userState";
//utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import { checkSheetState, compState, loadingBoxState, spgState } from "../../../recoil/menuState";
import { useTrans } from "../../../utils/langs/useTrans";
function SpgTree(props) {
    //navigate
    const navigate = useNavigate();
    const t = useTrans();
    //recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const [checksheet, setCheckSheet] = useRecoilState(checkSheetState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [reloadSpgs, setReloadSpgs] = useRecoilState(reloadSpg);
    const [spgs, setSpgs] = useRecoilState(spgState);
    const [comps, setComps] = useRecoilState(compState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    //props
    const { checksheetName, setWorkMode, workMode, spgType, setSpgType } = props;
    //
    const [lsSpg, setLsSpg] = useState([]);
    const [companys, setCompanys] = useState([]);
    const [compSpg, setCompSpg] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [treeSearchText, setTreeSearchText] = useState("");
    const [companySel, setCompanySel] = useState(null);
    //기본유형 spg Tree
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/spgs`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: workMode + reload + spgType,
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                if (userInfo.role == CONST.USERROLE_ADMIN && workMode == "READ" && spgType == checksheetName[0]) {
                    if (spgs.spgId <= 0) {
                        setCheckSheet({
                            sheetType: checksheetName[0],
                            spgName: data.body[0].spgName,
                        });
                        setSpgs({
                            spgId: data.body[0].spgId,
                            compSpgId: data.body[0].spgId,
                            companySpgId: -1,
                            spgName: data.body[0].spgName,
                        });
                    }
                    SpgSelect(checksheetName[0], null);
                }
                setLsSpg(data.body);
                setReload(false);
            }
            setRecoilIsLoadingBox(false);
        }
    }, [data, userInfo, reload, workMode, spgType]);
    //company spg Tree
    const { data: comData } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/company/spg/tree?search=${treeSearchText}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: workMode + reload + treeSearchText,
    });
    useEffect(() => {
        if (comData) {
            if (comData.codeNum == CONST.API_200) {
                let company = comps.id > 0 ? comData.body.filter((com) => com.id == comps.id)[0] : comData.body[0];
                if (userInfo.role !== CONST.USERROLE_ADMIN) {
                    if (workMode == "READ") {
                        setCheckSheet({
                            sheetType: checksheetName[1],
                            spgName: company.spg[0].spgName,
                        });
                        SpgSelect(checksheetName[1], comps);
                        setComps({
                            companyId: company.companyId,
                            companyName: company.companyName,
                            id: company.id,
                        });
                        companySpg(company, true, checksheetName[1]);
                        setCompanySel(company.companyId);
                    }
                }
                else {
                    if (spgType == checksheetName[1]) {
                        if (comps.companyId !== companySel) {
                            companySpg(company, true, checksheetName[1]);
                        }
                        else {
                            companySpg(company, false, checksheetName[1]);
                        }
                        setCompanySel(company.companyId);
                    }
                    else {
                        companySpg(company, false, checksheetName[0]);
                    }
                }
                setCompanys(comData.body);
            }
        }
    }, [comData, userInfo, reload, treeSearchText, workMode]);
    function companySpg(item, boolen, type) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/${item.companyId}/spgs`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setCompSpg(data.body);
                    if (type == checksheetName[1]) {
                        if (boolen) {
                            setSpgs({
                                spgId: spgs.spgId,
                                companySpgId: data.body[0].companySpgId,
                                compSpgId: data.body[0].spgId,
                                spgName: data.body[0].spgName,
                            });
                            spgClick(data.body[0], checksheetName[1]);
                        }
                        // }
                    }
                }
                else {
                }
            }
        });
    }
    // 설비 유형 선택
    function SpgSelect(type, company) {
        if (company) {
            let boolean = null;
            if (company.companyId !== comps.companyId) {
                setWorkMode("READ");
                boolean = true;
            }
            else {
                boolean = false;
            }
            companySpg(company, boolean, type);
            setComps({
                companyId: company.companyId,
                companyName: company.companyName,
                id: company.id,
            });
            setCompanySel(company.companyId);
        }
        else {
            setComps({
                companyId: "",
                companyName: "",
                id: -1,
            });
        }
        setCheckSheet({
            sheetType: type,
            spgName: checksheet.spgName,
        });
        setSpgType(type);
        if (type !== spgType) {
            setWorkMode("READ");
        }
    }
    // spg select
    function spgClick(item, type) {
        if (type == checksheetName[0]) {
            setSpgs({
                spgId: item.spgId,
                companySpgId: -1,
                compSpgId: -1,
                spgName: item.spgName,
            });
        }
        else {
            setSpgs({
                spgId: -1,
                compSpgId: item.spgId ? item.spgId : -1,
                companySpgId: item.companySpgId,
                spgName: item.spgName,
            });
            setReloadSpgs(true);
        }
        setCheckSheet({
            sheetType: type,
            spgName: item.spgName,
        });
        setWorkMode("READ");
    }
    // defalut spg 선택
    function lsSpgAdd(e) {
        setCheckSheet({
            sheetType: checksheetName[0],
            spgName: "",
        });
        setSpgs({
            spgId: -1,
            companySpgId: -1,
            compSpgId: -1,
            spgName: "",
        });
        setWorkMode("CREATE");
    }
    function ShearchGo(e) {
        setTreeSearchText(searchText);
    }
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            ShearchGo(e);
        }
    }
    // 검색 초기화
    function ShearchReset(e) {
        setSearchText("");
        setTreeSearchText("");
    }
    // company spg 선택
    function SpgAdd(e) {
        setCheckSheet({
            sheetType: checksheetName[1],
            spgName: "",
        });
        setSpgs({
            spgId: -1,
            companySpgId: -1,
            compSpgId: -1,
            spgName: "",
        });
        setWorkMode("CREATE");
    }
    return (_jsxs(_Fragment, { children: [userInfo.loginInfo.role == CONST.USERROLE_ADMIN && (_jsxs("div", Object.assign({ className: "box__search input__direct" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.회사명을검색하세요"), onKeyDown: (e) => searchEnter(e), value: searchText, onChange: (e) => setSearchText(e.target.value) }), searchText.length > 0 && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => ShearchReset(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uAC80\uC0C9\uC5B4 \uC0AD\uC81C" })) }))), _jsx("button", Object.assign({ type: "button", className: "btn btn-search", onClick: (e) => ShearchGo(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC870\uD68C" })) }))] }))), _jsx("div", Object.assign({ className: "lnb" }, { children: _jsxs("ul", Object.assign({ className: "lnb-depth1" }, { children: [userInfo.loginInfo.role == CONST.USERROLE_ADMIN && (_jsxs("li", Object.assign({ className: spgType == checksheetName[0] ? "active" : "", onClick: (e) => SpgSelect(checksheetName[0], null) }, { children: [_jsx("p", { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("span", { children: t("라벨.기본설비유형") }) })) }), lsSpg && (_jsxs("ul", Object.assign({ className: "lnb-depth2 basic" }, { children: [lsSpg.map((item, idx) => (_jsx("li", Object.assign({ className: `${!comps.companyId && spgs.spgId == item.spgId ? "active" : ""}`, onClick: (e) => spgClick(item, checksheetName[0]) }, { children: _jsxs("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: [_jsx("p", { children: item.spgName }), !item.isActive && _jsx("span", Object.assign({ className: "txt" }, { children: t("라벨.체크시트없음") }))] })) }), "lsSpg_" + idx.toString()))), _jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "add__item", onClick: (e) => lsSpgAdd(e) }, { children: _jsx("span", { children: t("라벨.신규설비유형추가하기") }) })) })] })))] }))), companys.length > 0 ? (companys.map((company, idx) => (_jsxs("li", Object.assign({ className: comps.id == company.id ? "active" : "", onClick: (e) => SpgSelect(checksheetName[1], company) }, { children: [_jsx("p", { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("span", { children: company.companyName }) })) }), _jsxs("ul", Object.assign({ className: "lnb-depth2" }, { children: [_jsx(CompanySpgs, { spgClick: spgClick, checksheetName: checksheetName, spg: compSpg }), _jsx("li", { children: _jsxs("button", Object.assign({ type: "button", className: "add__item", onClick: (e) => SpgAdd(e) }, { children: [" ", _jsx("span", { children: t("라벨.신규설비유형추가하기") })] })) })] }))] }), "companys_" + idx.toString())))) : (_jsx("li", Object.assign({ className: "lnb nodata" }, { children: _jsx("p", Object.assign({ className: "nodata_txt" }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("span", { children: t("라벨.검색결과가없습니다") }) })) })) })))] })) }))] }));
}
export default SpgTree;
function CompanySpgs(props) {
    const t = useTrans();
    const [spgs, setSpgs] = useRecoilState(spgState);
    const [comps, setComps] = useRecoilState(compState);
    const { spgClick, spg, checksheetName } = props;
    return (_jsx(_Fragment, { children: spg.map((item, idx) => (_jsx("li", Object.assign({ className: `${comps.companyId && spgs.companySpgId == item.companySpgId ? "active" : ""}`, onClick: (e) => spgClick(item, checksheetName[1]) }, { children: _jsxs("a", Object.assign({ href: "#", className: !item.isonSpg ? "dis" : "", onClick: (e) => e.preventDefault() }, { children: [_jsxs("p", { children: [item.spgName, " ", item.spgId > 0 ? `(${t("라벨.기본")})` : ""] }), !item.isActive && _jsx("span", Object.assign({ className: "txt" }, { children: t("라벨.체크시트없음") }))] })) }), "comspg_" + idx.toString()))) }));
}
